module.exports = __webpack_public_path__ + "a54fe773a9a6f8f7ae6054c89fb0f33c.svg";